export const classes = {
  container: {
    margin: "2%",
  },
  tabContainer: { margin: "2% 0%" },
  activeCrumb: { color: "#250996" },
  inactiveCrumb: { cursor: "pointer" },
};
